import * as React from "react";
import { RadiosEditor } from "../../../../../../../react-core/Html/RadiosEditor";
import { DrawdownModel } from "../../../../../../../Wrap/Models/Models/QuoteAndApplyBase/Shared/DrawdownModel";
import { IProcessComponentProps, ProcessComponent } from "../../../../../../Shared/Process/Process/ProcessComponent";
import { SectionHeader } from "../../SharedComponents";
import { PoundLockIcon } from "../../../../ToolsAndLiterature/Components/Icons/PoundLockIcon";
import { ContextStore } from "../../../../../../../react-core/Flux/Variables";
import { DrawdownCalculationAction } from "./Action/DrawdownCalculationAction";
import { ServiceCharge } from "../../../../../../../Wrap/Models/Models/Charges/ServiceCharge";
import { DrawdownPriceLockIcon } from "./Icon/DrawdownPriceLockIcon";
import AriaTooltip from "../../../../../../Shared/Tooltip/AriaTooltip";
import { DrawdownPriceLockMessage } from "./Resource/Contents";
import { DrawdownPriceLockModel } from "../../../../../../../Wrap/Models/Models/QuoteAndApplyBase/Shared/DrawdownPriceLockModel";
import { ProductOverviewChargeAction } from "../../../PortfolioDashboard/Components/ProductOverview/Action/ProductOverviewChargeAction";

interface IDrawdownPriceLockProps extends IProcessComponentProps {
    data: DrawdownModel;
    hierarchyId: string;
    subaccountHierarchyId?: string;
    totalPea?: number;
}

interface IDrawdownPriceLockState {
}

export class DrawdownPriceLock extends ProcessComponent<IDrawdownPriceLockProps, IDrawdownPriceLockState> {
    private isAdminUser: boolean;
    constructor(props: any) {
        super(props);
        this.state = {};
        this.isAdminUser = ContextStore.getContext().isAdminUser;
    }

    public render(): JSX.Element {
        const { data, hierarchyId, subaccountHierarchyId, onChange, totalPea } = this.props;

        return (
            <>
                {SectionHeader("Drawdown Price Lock")}
                <RadiosEditor
                    label="Do you want to apply the Drawdown Price Lock?"
                    options={[true, false]}
                    getText={(v) => (v ? "Yes" : "No")}
                    onChange={(v) => {
                        v ?
                            DrawdownCalculationAction.getEstimatedPlatformChargeRate(hierarchyId,
                                totalPea ?? data?.TaxFreeLumpSum?.Amount,
                                (serviceCharges: ServiceCharge[]) => {
                                    subaccountHierarchyId != null
                                        ? ProductOverviewChargeAction.getDrawdownPriceLock(subaccountHierarchyId,
                                        (drawdownPriceLockModel: DrawdownPriceLockModel) => {
                                            let rate = serviceCharges?.[0]?.Rate;

                                            if (drawdownPriceLockModel?.UsePriceLock &&
                                                drawdownPriceLockModel?.AppliedRate > 0 &&
                                                drawdownPriceLockModel?.AppliedRate < rate) {
                                                rate = drawdownPriceLockModel?.AppliedRate;
                                            }

                                            onChange({ DrawdownPriceLock: v, DrawdownPriceLockPercentage: rate });
                                        }) :
                                        onChange({ DrawdownPriceLock: v, DrawdownPriceLockPercentage: serviceCharges?.[0]?.Rate });
                            }) : onChange({ DrawdownPriceLock: v, DrawdownPriceLockPercentage: 0 });
                    }}
                    selected={data?.DrawdownPriceLock ? data?.DrawdownPriceLock : false}
                    disabled={data?.DrawdownPriceLock == null || this.isAdminUser ? false : data?.DrawdownPriceLock}
                    cssWrapper="rg-inline mb-10"
                />
                {data?.DrawdownPriceLock && (
                    <>
                        <p>
                            Applying the Drawdown Price Lock means the platform charge for the Aberdeen SIPP won’t go up as money is taken out of the pension and the value is reduced.
                            The lock will be recalculated each month when the platform charge is due and automatically adjusted if a better charge value is identified.
                            The current lock rate is reflected below
                        </p>
                        <div className="row">
                            <div className="col-6">
                                <div className="panel-total-income">
                                    <div className="row">
                                        <div className="col-auto">
                                            <DrawdownPriceLockIcon />
                                        </div>
                                        <div className="col-fluid">
                                            <h4 className="">Drawdown Price Lock {" "}
                                                <AriaTooltip showCloseButton={true} cssWrapper="is-info-icon">
                                                    {DrawdownPriceLockMessage.TooltipMessage}
                                                </AriaTooltip>
                                            </h4>
                                            <div>{Math.round(data.DrawdownPriceLockPercentage * 100) / 100}%</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                )}
            </>
        );
    }
}
